import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

export default function CommentViewItem({ comment }) {
  const [state, setState] = useState({
    MoreImg: false,
    dispaly: false,
  });

  const recommendStatus = {
    2: {
      color: "#FF4C4C",
      text: "پیشنهاد نمیکنم",
      image: "/public/assets/dislik.svg",
    },
    1: {
      color: "#33AA57",
      text: "پیشنهاد میکنم",
      image: "/public/assets/finger.svg",
    },
    0: {
      color: "#F7A600",
      text: "مطمعن نیستم",
      image: "/public/assets/alamat.svg",
    },
  };
  const ShowMoreImg = (id) => {
    setState({ ...state, MoreImg: !state.MoreImg });
  };
  return (
    <div className='BodyCommentView'>
      <span className='Taitle'>{comment.details.title}</span>
      <div className='suggestion'>
        <img src={recommendStatus[comment.is_recommended].image} alt='pic' />
        <span>{recommendStatus[comment.is_recommended].text}</span>
      </div>
      <div className='Information'>
        <span>{comment.name}</span>
        <span>&#8226;</span>
        <span>خریدار</span>
        <span>&#8226;</span>
        <span>{comment.time}</span>
        <span className='NumberInfo'>{comment.rate}</span>
      </div>
      <p>{comment.details.text}</p>
      <div className='Showmore' onClick={() => ShowMoreImg()}>
        {state.MoreImg && (
          <>
            <div className='commentShowmore'>
              <Swiper className='mySwiper' slidesPerView={1} spaceBetween={20}>
                {comment.images.map((image) => (
                  <SwiperSlide>
                    <div className='commentPics'>
                      <img src={image} alt='car' />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            <div className='commentAdvDis'>
              <div className='commentAdvantages'>
                {comment.details.advantages.map((advantage) => (
                  <div>
                    <span className='SymbolPlus'>&#43;</span>
                    <span className='Text'>{advantage}</span>
                  </div>
                ))}
              </div>
              <div className='commentDisAdvantages'>
                {comment.details.disadvantages.map((disadvantage) => (
                  <div>
                    <span className='SymbolMinus'>&#8722;</span>
                    <span className='Text'>{disadvantage}</span>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
        <div className='MoreImage'>
          <span>مشاهده بیشتر</span>
          <img src='/public/assets/arrow.dow.svg' alt='pic' />
        </div>
      </div>
    </div>
  );
}
